import type { TransactionActionCapabilityDefinition } from '../../capabilities';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import type { RecategorizeEligibleTransaction } from './types';
import { parseRecategorizeAssistantResponse } from './validators';

// Capability definition (plugin-contract step 1 in docs/features/transaction-actions/README.md):
// registers recategorize's runner id, execution profile, and structured-response parser with the
// framework's capability registry (see ../../capabilities.ts).
export const recategorizeTransactionActionCapability: TransactionActionCapabilityDefinition = {
  capability: 'recategorize',
  supportedInPhase1: true,
  executionProfile: transactionActionExecutionProfiles.recategorize,
  runnerId: 'structured_model',
  // The framework's parseStructuredResponse contract takes the base
  // TransactionActionEligibleTransaction[], but this capability's own eligible-transaction
  // snapshot is a superset (see types.ts). The cast is safe because the framework only ever
  // calls this with recategorize's own batch.eligibleTransactions.
  parseStructuredResponse: (eligibleTransactions, assistantResponse) =>
    parseRecategorizeAssistantResponse(eligibleTransactions as RecategorizeEligibleTransaction[], assistantResponse),
};
